import { render, staticRenderFns } from "./2021-2-7-gift.vue?vue&type=template&id=71b4cdcc&scoped=true&"
import script from "./2021-2-7-gift.vue?vue&type=script&lang=ts&"
export * from "./2021-2-7-gift.vue?vue&type=script&lang=ts&"
import style0 from "./2021-2-7-gift.vue?vue&type=style&index=0&id=71b4cdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4cdcc",
  null
  
)

export default component.exports